import EnumClass, { build } from '../EnumClass';
import data, { BookingCancellationTypeId, BookingCancellationTypeData } from './data';
import * as Translations from './translations';

export class BookingCancellationType extends EnumClass<BookingCancellationTypeId, BookingCancellationTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: BOOKING_CANCELLATION_TYPES,
  getById: getBookingCancellationTypeById,
  marshaller: BookingCancellationTypeMarshaller,
} = build<BookingCancellationTypeId, BookingCancellationTypeData, BookingCancellationType>(
  'BookingCancellationTypeEnum',
  data,
  BookingCancellationType,
);
